/**
 * The numbers every Kit guide must agree with. Single source inside the
 * portal; the guides interpolate these rather than hardcoding figures, so a
 * pricing change is one edit. Values per spec §10 (rulings 2026-08-22/23).
 */
export const FACTS = {
  deliveryFeeUsd: 7,
  lanePassPerDeliveryUsd: 2,
  lanePassWeeklyMaxUsd: 60,
  lanePassGraceDays: 30,
  customerConfirmHours: 24,
  payoutCadence: { en: 'weekly', es: 'semanal' },
  trustedRunner: { days: 30, deliveries: 50, satisfactionPct: 95 },
  complaintsLadder: { reviewAt: 3, windowDays: 30, suspendAt: 5 },
  taxSetAsidePct: { low: 25, high: 30 },
} as const;
